import { create } from 'zustand';

export type SortKey = 'name' | 'category' | 'status' | 'semver' | 'updated_at' | 'usage';
export type SortDir = 'asc' | 'desc';
export type StatusFilter = 'all' | 'draft' | 'published' | 'archived' | 'standard';

interface ExcelenciaFiltersState {
  organizationId: string;
  page: number;
  pageSize: number;
  sortKey: SortKey;
  sortDir: SortDir;
  status: StatusFilter;
  category: string | 'all';
  search: string;
  setOrganization: (id: string) => void;
  setPage: (page: number) => void;
  setPageSize: (size: number) => void;
  setSort: (key: SortKey, dir?: SortDir) => void;
  setStatus: (status: StatusFilter) => void;
  setCategory: (category: string | 'all') => void;
  setSearch: (q: string) => void;
  reset: () => void;
}

const initialState = {
  organizationId: '',
  page: 1,
  pageSize: 25,
  sortKey: 'updated_at' as SortKey,
  sortDir: 'desc' as SortDir,
  status: 'all' as StatusFilter,
  category: 'all' as const,
  search: '',
};

export const useExcelenciaFiltersStore = create<ExcelenciaFiltersState>((set) => ({
  ...initialState,
  setOrganization: (id) => set({ organizationId: id, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (size) => set({ pageSize: size, page: 1 }),
  setSort: (key, dir) => set((s) => ({ sortKey: key, sortDir: dir ?? (s.sortDir === 'asc' ? 'desc' : 'asc'), page: 1 })),
  setStatus: (status) => set({ status, page: 1 }),
  setCategory: (category) => set({ category, page: 1 }),
  setSearch: (search) => set({ search, page: 1 }),
  reset: () => set(initialState),
}));
